import React from 'react';

export class ProductRow extends React.Component<{ options: any; }> {
    render() {
        return <tr className={this.props.options.className}>{this.props.children}</tr>;
    }
}
